import { onMounted, onUnmounted, watch } from 'vue'

import { useLayoutStore } from '@/features/layout/useLayoutStore.js'

export function useHeaderRightActions(actions) {
  const layoutStore = useLayoutStore()

  onMounted(() => {
    layoutStore.setHeaderRightActions(actions)
  })

  onUnmounted(() => {
    layoutStore.resetHeaderRightActions()
  })

  watch(
    () => actions,
    () => {
      layoutStore.setHeaderRightActions(actions)
    },
    {
      deep: true,
      immediate: true,
    },
  )
}
